(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("base"), require("core"));
	else if(typeof define === 'function' && define.amd)
		define(["base", "core"], factory);
	else if(typeof exports === 'object')
		exports["module-mobile-utils"] = factory(require("base"), require("core"));
	else
		root["module-mobile-utils"] = factory(root["base"], root["core"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict'; /**
	               *  ----------------------------------------------------------------
	               *  Copyright © Mobiquity INC
	               *  ----------------------------------------------------------------
	               *  Author : Dhaval Marthak
	               *  Filename : main.js
	               *  Description:
	               *  Main File Module Sample
	               *  ----------------------------------------------------------------
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    module.name = 'module-mobile-utils';

	    var base = __webpack_require__(3);
	    var core = __webpack_require__(4);

	    var deps = [
	    core.name];


	    module.exports = base.createModule(module.name, deps).
	    factory(__webpack_require__(5)).
	    factory(__webpack_require__(6)).
	    factory(__webpack_require__(7)).
	    service(__webpack_require__(8));
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {
	    'use strict';

	    // @ngInject
	    exports.MobileAlertService = function (TranslateService, lpConstants, $rootScope, lpCoreError) {

	        function getContinueButton() {
	            return {
	                type: lpConstants.MOBILE_SDK_BUTTONS.POSITIVE,
	                text: TranslateService.translate('abc.common.button.continue'),
	                callback: null };

	        }

	        function getCloseButton() {
	            return {
	                type: lpConstants.MOBILE_SDK_BUTTONS.POSITIVE,
	                text: TranslateService.translate('abc.common.button.close'),
	                callback: null };

	        }

	        function getOkButton() {
	            return {
	                type: lpConstants.MOBILE_SDK_BUTTONS.POSITIVE,
	                text: TranslateService.translate('abc.common.button.ok'),
	                callback: null };

	        }

	        function show(message, buttons) {
	            if (!buttons || buttons.length === 0) {
	                lpCoreError.throwException('Should have buttons, else cannot close notification');
	                return;
	            }
	            var buttonsForSdk = [];
	            buttons.forEach(function (button, index) {
	                buttonsForSdk.push({
	                    type: button.type,
	                    text: button.text,
	                    callbackFn: index.toString() });

	            });
	            try {
	                window.cxp.mobile.plugins['AlertDialog'].show(buttonHandler.bind(this, buttons), null, "", TranslateService.translate(message), JSON.stringify(buttonsForSdk));
	            }
	            catch (e) {
	                lpCoreError.throwException('Error getting [AlertDialog] plugin from sdk.');
	            }

	        }

	        function buttonHandler(buttons, data) {
	            var callbackIndex = parseInt(data.callback);
	            if (!isNaN(callbackIndex)) {
	                var buttonTapped = buttons[callbackIndex];
	                !!buttonTapped.callback && buttonTapped.callback();
	            }
	        }

	        function showProcessing(message) {
	            var i18nMessage = TranslateService.translate(message);
	            $rootScope.loaderMessage = i18nMessage;
	            gadgets.pubsub.publish(lpConstants.PUBLISH.SHOW_PROGRESS, { "alertTitle": i18nMessage });
	        }

	        // public API
	        return {
	            show: show,
	            getContinueButton: getContinueButton,
	            getOkButton: getOkButton,
	            getCloseButton: getCloseButton,
	            showProcessing: showProcessing };

	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               * Created by dmarthak on 06/02/18.
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    // @ngInject
	    exports.TranslateService = function (lpCoreI18n) {
	        function translate(key) {
	            return lpCoreI18n.instant(key) || key;
	        }
	        return {
	            translate: translate };

	    };

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               * Created by dmarthak on 08/02/18.
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';
	    // @ngInject
	    exports.CommonService = function (lpPortal, lpCoreBus, lpConstants, lpCoreUtils, $q, $timeout, $window, $http, TranslateService, MobileAlertService) {
	        var isMobileNative = window.cxp && window.cxp.mobile ? true : false;
	        var digiPassPlugin;
	        var urls = {
	            logOutUrl: lpPortal.root + '/bb-public-api/security/logout',
	            userStatusUrl: lpPortal.root + '/services/rest/v1/user-status' };


	        if ($window.cxp && $window.cxp.mobile && $window.cxp.mobile.plugins) {
	            digiPassPlugin = $window.cxp.mobile.plugins['DigiPass'];
	        }

	        function isNative() {
	            return $window.cxp && $window.cxp.mobile ? true : false;
	        }

	        //check if user session exceeds
	        function validateSession(X_BBSCCOUNT) {
	            return X_BBSCCOUNT > 1;
	        }
	        //check if user is vasco registered
	        function IsUserDigipassRegistered() {
	            var deferred = $q.defer();
	            if (digiPassPlugin) {
	                digiPassPlugin.isDigiPassRegister(function (response) {
	                    var isDigiPassRegistered = response.data || false;
	                    deferred.resolve(isDigiPassRegistered);
	                }, function (response) {
	                    var isDigiPassRegistered = response.error || false;
	                    deferred.reject(isDigiPassRegistered);
	                });
	            } else {
	                deferred.reject(false);
	            }
	            return deferred.promise;
	        }
	        //show title on the header bar
	        function toggleTitlebar(showTitlebar, title) {
	            showTitlebar && isMobileNative ? lpCoreBus.publish(lpConstants.PUBLISH.TOOLBAR_ENABLE, { "title": title }) : lpCoreBus.publish(lpConstants.PUBLISH.TOOLBAR_DISABLE);
	        }
	        //common logout
	        function logout() {
	            var data = {
	                BBXSRF: localStorage.getItem('token'),
	                portal_name: lpPortal.name,
	                page_name: lpPortal.page.name };


	            $http.post(urls.logOutUrl, lpCoreUtils.buildQueryString(data), {
	                headers: {
	                    'Accept': 'application/json',
	                    'Content-Type': 'application/x-www-form-urlencoded;',
	                    'Cache-Control': 'no-cache, no-store, must-revalidate',
	                    'Pragma': 'no-cache',
	                    'Expires': '0' } }).

	            then(function (response) {
	                clearAndSignOut();
	            }, function (response) {
	                clearAndSignOut();
	            });
	        }

	        //get user status to accept terms and condition while onboarding process
	        function getUserStatus() {
	            return $http.get(urls.userStatusUrl);
	        }

	        function serverErrorAlert(callBack) {
	            var message = TranslateService.translate("abc.common.error.oops") + " " + TranslateService.translate("abc.common.system.down.message");
	            var buttons = [{
	                type: lpConstants.MOBILE_SDK_BUTTONS.POSITIVE,
	                text: TranslateService.translate("abc.common.button.ok"),
	                callback: callBack }];

	            MobileAlertService.show(message, buttons);
	        }

	        //Private function
	        function clearAndSignOut() {
	            localStorage.clear();
	            window.cxp && window.cxp.mobile ? lpCoreBus.publish(lpConstants.PUBLISH.SIGNOUT) : $window.location.href = lpPortal.root + '/' + lpPortal.name + '/sign-in';
	        }

	        function preventPageScroll(payload) {
	            var overflowVal = payload ? 'hidden' : '';
	            $timeout(function () {
	                $('body').css('overflow', overflowVal);
	            }, 0);
	        }
	        //pass country and check if this country matches with current (loggedin) country
	        function isValueDateEnabled(currentCountry, allowedCountries) {
	            return currentCountry && allowedCountries ? allowedCountries.toLowerCase().trim().split(lpConstants.IGNORE_SPACE_REGEX).indexOf(currentCountry.toLowerCase()) > -1 : false;
	        }

	        function downloadFile(payload) {
	            var linkElement = document.createElement('a');
	            var fileName = payload.fileName;
	            var content = 'data:' + payload.mimeType + ';base64,' + payload.fileData;
	            linkElement.setAttribute('href', content);
	            linkElement.setAttribute('download', fileName);
	            // IE workaround
	            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
	                var byteCharacters = atob(payload.fileData);
	                var byteNumbers = [];
	                for (var i = 0; i < byteCharacters.length; i++) {
	                    byteNumbers.push(byteCharacters.charCodeAt(i));
	                }
	                var byteArray = new Uint8Array(byteNumbers);
	                var blob = new Blob([byteArray], { type: payload.mimeType + ";charset=utf-8" });
	                window.navigator.msSaveBlob(blob, fileName);
	            } else

	            {
	                var clickEvent = new MouseEvent("click", {
	                    "view": window,
	                    "bubbles": true,
	                    "cancelable": false });

	                linkElement.dispatchEvent(clickEvent);
	            }
	        }


	        function deleteText(event) {
	            if (!event || !event.target) {
	                return;
	            }
	            var element = angular.element(event.target);
	            if (element) {
	                var isFirefox = typeof InstallTrigger !== 'undefined';
	                var val = element.val();
	                if (event.keyCode == 8 && isFirefox) {
	                    val = val.slice(0, val.length - 1);
	                    element.val(val);
	                    event.preventDefault();
	                }
	            }
	        }
	        return {
	            isNative: isNative,
	            validateSession: validateSession,
	            IsUserDigipassRegistered: IsUserDigipassRegistered,
	            toggleTitlebar: toggleTitlebar,
	            logout: logout,
	            getUserStatus: getUserStatus,
	            serverErrorAlert: serverErrorAlert,
	            preventPageScroll: preventPageScroll,
	            isValueDateEnabled: isValueDateEnabled,
	            downloadFile: downloadFile,
	            deleteText: deleteText };

	    };

	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict"; /**
	               * Created by dmarthak on 23/01/18.
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    'use strict';

	    // @ngInject
	    exports.mobileTokenGeneratorService = function ($http, $window, lpPortal, lpCoreUtils, $q) {

	        var servicePath = lpPortal.root + "/services/rest",deviceInfoPlugin,appPinPlugin,deviceInfo = null,payload = {};
	        var config = {
	            generateDeviceTokenUrl: servicePath + "/v1/registration/device/token" };


	        if ($window.cxp && $window.cxp.mobile && $window.cxp.mobile.plugins) {
	            deviceInfoPlugin = $window.cxp.mobile.plugins['DeviceInfo'];
	            appPinPlugin = $window.cxp.mobile.plugins['AppPin'];
	        }

	        //methods
	        this.generateDeviceToken = function () {
	            var deferred = $q.defer();
	            generateTokenFromPlugin().then(function (response) {
	                $http.post(config.generateDeviceTokenUrl, response).then(function (response) {
	                    deferred.resolve(response.data);
	                }, function (response) {
	                    deferred.reject(response);
	                });
	            });
	            return deferred.promise;
	        };

	        function generateTokenFromPlugin() {
	            var deferred = $q.defer();
	            if (deviceInfoPlugin) {
	                deviceInfoPlugin.getInfo(function (response) {
	                    if (response) {
	                        deviceInfo = response;
	                        payload = {
	                            deviceType: JSON.stringify(deviceInfo.deviceType),
	                            accessTokenAppString: deviceInfo.accessTokenAppString };

	                        deferred.resolve(payload);
	                    }
	                }, function (response) {
	                    deferred.reject(response);
	                });
	            } else {deferred.reject("failed");}
	            return deferred.promise;
	        }

	        this.saveAppToken = function (resolve, reject, token) {
	            if (appPinPlugin) {
	                appPinPlugin.saveAppToken(resolve, reject, token);
	            }
	        };
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// scripts/main.js